(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["infinity-scroll-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  
(() => {
  const selector = '[data-announcement-rotator]';

  function initAnnouncementRotator(root) {
    if (root.dataset.rotatorInitialized === 'true') return;

    root.dataset.rotatorInitialized = 'true';

    const slides = Array.from(
      root.querySelectorAll('[data-announcement-slide]')
    );
    const closeButton = root.querySelector('[data-announcement-close]');
    const interval = Number(root.dataset.interval) || 4000;

    let currentIndex = 0;
    let timer = null;

    if (slides.length === 0) return;

    function showSlide(nextIndex) {
      const currentSlide = slides[currentIndex];
      const nextSlide = slides[nextIndex];

      if (!currentSlide || !nextSlide || currentIndex === nextIndex) return;

      currentSlide.classList.remove('is-active');
      currentSlide.classList.add('is-leaving');
      currentSlide.setAttribute('aria-hidden', 'true');

      nextSlide.classList.remove('is-leaving');
      nextSlide.classList.add('is-active');
      nextSlide.setAttribute('aria-hidden', 'false');

      currentIndex = nextIndex;

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
      }, 500);
    }

    function stopRotation() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function startRotation() {
      stopRotation();

      if (slides.length < 2 || root.classList.contains('is-dismissed')) {
        return;
      }

      timer = window.setInterval(() => {
        const nextIndex = (currentIndex + 1) % slides.length;
        showSlide(nextIndex);
      }, interval);
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        stopRotation();
        root.classList.add('is-dismissed');
        root.setAttribute('aria-hidden', 'true');
      });
    }

    // Pause while the visitor hovers over the announcement.
    root.addEventListener('mouseenter', stopRotation);
    root.addEventListener('mouseleave', startRotation);

    // Pause when the browser tab is not visible.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopRotation();
      } else {
        startRotation();
      }
    });

    startRotation();
  }

  function initAllAnnouncementRotators() {
    document.querySelectorAll(selector).forEach(initAnnouncementRotator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initAllAnnouncementRotators
    );
  } else {
    initAllAnnouncementRotators();
  }

  // Support Shopify theme editor section reloads.
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    const rotator = section.matches(selector)
      ? section
      : section.querySelector(selector);

    if (rotator) {
      rotator.dataset.rotatorInitialized = 'false';
      initAnnouncementRotator(rotator);
    }
  });
})();


  } catch(e) { console.error(e); }
})();
})();
